import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/common/guide_main.png'
import _imports_1 from '@/assets/images/common/guide_1.png'
import _imports_2 from '@/assets/images/common/guide_2.png'
import _imports_3 from '@/assets/images/common/guide_3.png'
import _imports_4 from '@/assets/images/common/guide_4.png'


const _withScopeId = n => (_pushScopeId("data-v-00cfb83a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "guide-view-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "main",
  src: _imports_0
}, null, -1))
const _hoisted_3 = { class: "guide-options" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<img src=\"" + _imports_1 + "\" data-v-00cfb83a><div class=\"title\" data-v-00cfb83a>猫狗小课堂</div><div class=\"desc\" data-v-00cfb83a>你的一静一动</div><div class=\"desc\" data-v-00cfb83a>牵引着我得所有目光</div><div class=\"click-btn animate__animated animate__rubberBand animate__delay-1s\" data-v-00cfb83a>进入</div>", 5)
const _hoisted_9 = [
  _hoisted_4
]
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<img src=\"" + _imports_2 + "\" data-v-00cfb83a><div class=\"title\" data-v-00cfb83a>宠物百科</div><div class=\"desc\" data-v-00cfb83a>让我看看你这小东西</div><div class=\"desc\" data-v-00cfb83a>都有什么小秘密</div><div class=\"click-btn animate__animated animate__rubberBand animate__delay-2s\" data-v-00cfb83a>进入</div>", 5)
const _hoisted_15 = [
  _hoisted_10
]
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<img src=\"" + _imports_3 + "\" data-v-00cfb83a><div class=\"title\" data-v-00cfb83a>心情测试机</div><div class=\"desc\" data-v-00cfb83a>快让我测测</div><div class=\"desc\" data-v-00cfb83a>它现在心情怎么样</div><div class=\"click-btn animate__animated animate__rubberBand animate__delay-3s\" data-v-00cfb83a>进入</div>", 5)
const _hoisted_21 = [
  _hoisted_16
]
const _hoisted_22 = /*#__PURE__*/_createStaticVNode("<img src=\"" + _imports_4 + "\" data-v-00cfb83a><div class=\"title\" data-v-00cfb83a>宠物星座</div><div class=\"desc\" data-v-00cfb83a>喵喵教 &amp; 汪汪教</div><div class=\"desc\" data-v-00cfb83a>看看它是什么星座吧</div><div class=\"click-btn animate__animated animate__rubberBand animate__delay-4s\" data-v-00cfb83a>进入</div>", 5)
const _hoisted_27 = [
  _hoisted_22
]
const _hoisted_28 = { class: "fixed-bottom" }

import IcpComp from '@/components/IcpComp.vue';

import bus from '@haa/fwk-h5/lib/bus';
import { Haa, OeReportType, OeReportSubType } from '@haa/fwk-h5/lib/index';
import { ref, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'GuideView',
  setup(__props) {

Haa.util().useLifeCycle();

const { strategy } = Haa.util().useStrategy();
const { oeReport } = Haa.util().useOeReport();
let globalClickable = ref<boolean>(false), timeout = ref<number>(-1), strategyTimer: any = null;
const setGuideParams = () => {
    if (strategy.guide_click_enable == 1) globalClickable.value = true;
    if (strategy.guide_timeout >= 0) timeout.value = strategy.guide_timeout;
    if (timeout.value > -1) {
        strategyTimer = setTimeout(() => {
            oeReport(OeReportType.Action, OeReportSubType.BtnClick, 'Guide', '策略倒计时进入');
            handleClick('');
        }, timeout.value * 1000);
    }
}
if (strategy.status != 0) {
    setGuideParams();
} else {
    bus.on('strategy', setGuideParams);
}
onUnmounted(() => {
    if (strategyTimer) {
        clearTimeout(strategyTimer);
        strategyTimer = null;
    }
})

const handleTouch = () => {
    if (!globalClickable.value) return;
    oeReport(OeReportType.Action, OeReportSubType.BtnClick, 'Guide', 'touch非点击区域');
    handleClick('');
}

const router = useRouter();
const { openWindow } = Haa.util().useOeReport();
const handleClick = (path: string) => {
    let result = openWindow({ skip: '1' });
    if (!result) router.replace({ path: '/main' });
}
const handleTouchItem = (path: string) => {
    oeReport(OeReportType.Action, OeReportSubType.BtnClick, 'Guide', 'touch可点击区域');
    handleClick(path);
}

return (_ctx: any,_cache: any) => {
  const _component_wap_native = _resolveComponent("wap-native")!
  const _component_wap_banner = _resolveComponent("wap-banner")!

  return (_openBlock(), _createElementBlock("div", {
    class: "guide-view-wrapper",
    onTouchstart: handleTouch
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "option-item animate__animated animate__backInLeft",
          onTouchstart: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (handleTouchItem('classroom')), ["stop"]))
        }, _hoisted_9, 32),
        _createElementVNode("div", {
          class: "option-item animate__animated animate__backInRight animate__delay-1s",
          onTouchstart: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (handleTouchItem('wikipedia')), ["stop"]))
        }, _hoisted_15, 32),
        _createElementVNode("div", {
          class: "option-item animate__animated animate__backInLeft animate__delay-2s",
          onTouchstart: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (handleTouchItem('mood')), ["stop"]))
        }, _hoisted_21, 32),
        _createElementVNode("div", {
          class: "option-item animate__animated animate__backInRight animate__delay-3s",
          onTouchstart: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (handleTouchItem('constellation')), ["stop"]))
        }, _hoisted_27, 32)
      ])
    ]),
    _createVNode(_component_wap_native, { "space-key": "Guide_native" }),
    _createElementVNode("div", _hoisted_28, [
      _createVNode(IcpComp)
    ]),
    _createVNode(_component_wap_banner, { "space-key": "Guide_banner" })
  ], 32))
}
}

})